import { render, staticRenderFns } from "./cambio-jefe-hogar.vue?vue&type=template&id=bd361a7e&"
import script from "./cambio-jefe-hogar.vue?vue&type=script&lang=ts&"
export * from "./cambio-jefe-hogar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports